import config from "../../constants";

class ApiService {
  constructor() {
    this.baseURL = config.API_URL;
  }

  async request(endpoint, options = {}) {
    console.log('api service request')
    const accessToken = localStorage.getItem('access_token');
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...(accessToken && { 'Authorization': `Bearer ${accessToken}` }),
      },
      ...options,
    };

    let response = await fetch(`${this.baseURL}${endpoint}`, config);
    if (response.status === 401 && accessToken) {
      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        const refreshResponse = await fetch(`${this.baseURL}/wp/auth/refresh/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ refresh: refreshToken }),
        });
        if (refreshResponse.ok) {
          const data = await refreshResponse.json();
          localStorage.setItem('access_token', data.access);
          config.headers.Authorization = `Bearer ${data.access}`;
          response = await fetch(`${this.baseURL}${endpoint}`, config);
        }
      }
    }
    if (!response.ok) {
      throw new Error(`API Error: ${response.status}`);
    }
    return response.json();
  }

  async getUserContent() {
    return this.request('/wp/api/content/');
  }

  async createContent(data) {
    return this.request('/wp/api/content/', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }
}

export default new ApiService();
